import { createContext, useContext } from 'react';
import { OrgInfoOut as OrgInfo } from '../types/apiRequests';

export interface OrgInfoContextValue {
  orgInfo: OrgInfo | null;
  isBeheerder: boolean;
  refreshOrgInfo: () => void;
}

export const OrgInfoContext = createContext<OrgInfoContextValue | null>(null);

export function useOrgInfo(): OrgInfo | null {
  return useContext(OrgInfoContext)?.orgInfo ?? null;
}

export function useIsBeheerder(): boolean {
  return useContext(OrgInfoContext)?.isBeheerder ?? false;
}

export function useRefreshOrgInfo(): () => void {
  return useContext(OrgInfoContext)?.refreshOrgInfo ?? (() => {});
}
